import { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  TextField,
  Checkbox,
} from "@mui/material";
import Detail from "../../../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseFooterLists } from "./UseFooterLists";
import { useNavigate, useLocation } from "react-router-dom";
import ListItems from "./ListItems";
import useBreakpoints from "../../../../hooks/useBreakpoints";

export default function EditList(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { SetFooterList, validateList } = UseFooterLists();
  const [state, setState] = useState({
    id: undefined,
    isContactList: false,
    title: undefined,
    url: undefined,
  });
  const { isSmall } = useBreakpoints();

  const [errorState, setErrorState] = useState({
    title: false,
  });

  useEffect(() => {
    if (location.state && location.state.model) {
      setState({
        id: location.state.model.id,
        rowIndex: location.state.model.rowIndex,
        isContactList: location.state.model.isContactList,
        title: location.state.model.title,
        url: location.state.model.url,
      });
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/footerManage",
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/homepagemanage" },
          {
            name: "مدیریت فوتر",
            url: "/footerManage",
          },
          {
            name: "ویرایش لیست",
            url: "/footerManage/editList",
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            fullWidth
            value={state.title ? state.title : ""}
            label="عنوان"
            error={errorState.title}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, title: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 8"}>
          <TextField
            fullWidth
            value={state.url ? state.url : ""}
            label="لینک"
            sx={{
              textarea: { direction: "rtl" },
            }}
            multiline
            maxRows={4}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, url: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 4"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 2"}>
          <FormControlLabel
            control={
              <Checkbox
                checked={state.isContactList}
                onChange={(event) =>
                  setState({
                    ...state,
                    isContactList: event.target.checked,
                  })
                }
              />
            }
            label="لیست تماس"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 10"></Box>}
        <Box
          gridColumn="span 12"
          sx={{ display: "flex", justifyContent: "center", mb: 3 }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => {
              if (validateList(state, setErrorState) == 200) {
                setProgress(true);
                SetFooterList(state, (calback) => {
                  // navigate("/footerManage", {
                  //   state: { ...location.state, isBack: true },
                  //   replace: true,
                  // });
                });
              }
            }}
          >
            ثبت
          </Button>
        </Box>
      </Box>
      {location.state && location.state.model && (
        <ListItems
          listId={
            location.state && location.state.model && location.state.model.id
          }
          expanded={location.state && location.state.expanded}
          items={
            location.state && location.state.model ? location.state?.model : []
          }
        />
      )}
    </Detail>
  );
}
